<div class="col-xs-12">
  <form id="cadastroColheita_form" name="cadastroColheita_form" novalidate ng-submit="cadastroColheita.save(cadastroColheita_form)">
    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-default no-margin">
          <div class="panel-body">
            <!-- glebas -->
            <span ng-show="cadastroColheita.loading">
              <i class="pull-right fa fa-2x fa-spinner fa-spin"></i>
            </span>
            <div class="row">
              <div class="col-xs-6 col-md-6">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.safra.$invalid}">
                  <label>Safra</label>
                  <ui-select ng-disabled="cadastroColheita.colheita.id" name="safra" id="safra"
                             ng-model="cadastroColheita.colheita.safra" theme="bootstrap" ng-required="true"
                             ng-change="cadastroColheita.loadSeedings()">
                    <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao}}</ui-select-match>
                    <ui-select-choices repeat="safra in cadastroColheita.safras | filter: $select.search">
                      <span class="form-group" ng-bind-html="safra.descricao | highlight: $select.search"></span>
                    </ui-select-choices>
                  </ui-select>
                </div>
              </div>

              <div class="col-xs-6 col-md-6">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.gleba.$invalid}">
                  <label>Talhão</label>
                  <ui-select ng-disabled="cadastroColheita.colheita.id || cadastroColheita.glebaDisabled()"
                             name="gleba" id="gleba" ng-model="cadastroColheita.colheita.gleba" theme="bootstrap" required
                             ng-change="cadastroColheita.reset(false)">
                    <ui-select-match allow-clear="true" placeholder="">{{$select.selected.gleba.descricao}}</ui-select-match>
                    <ui-select-choices repeat="gleba in cadastroColheita.glebas | filter: $select.search">
                      <span class="form-group" ng-bind-html="gleba.gleba.descricao | highlight: $select.search"></span>
                    </ui-select-choices>
                  </ui-select>
                </div>
              </div>

              <div class="col-xs-6 col-md-6">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.atividade.$invalid}">
                  <label>Atividade</label>
                  <ui-select ng-disabled="cadastroColheita.colheita.id || cadastroColheita.atividadeDisabled()"
                             name="atividade" id="atividade" ng-model="cadastroColheita.colheita.atividade" theme="bootstrap" required
                             ng-change="cadastroColheita.colheita.insumo = null">
                    <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao}}</ui-select-match>
                    <ui-select-choices repeat="atividade in cadastroColheita.colheita.gleba.atividades | filter: $select.search">
                      <span class="form-group" ng-bind-html="atividade.descricao | highlight: $select.search"></span>
                    </ui-select-choices>
                  </ui-select>
                </div>
              </div>
              <div class="col-xs-6 col-md-6">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.insumo.$invalid}">
                  <label>Cultivar</label>
                  <ui-select ng-disabled="cadastroColheita.colheita.id || cadastroColheita.insumoDisabled() || !cadastroColheita.colheita.atividade.insumos.length"
                             name="insumo" id="insumo" ng-model="cadastroColheita.colheita.insumo" theme="bootstrap" required>
                    <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao}}</ui-select-match>
                    <ui-select-choices repeat="cultivares in cadastroColheita.colheita.atividade.insumos | filter: $select.search">
                      <span class="form-group" ng-bind-html="cultivares.descricao | highlight: $select.search"></span>
                    </ui-select-choices>
                  </ui-select>
                  <span class="help-block text-danger" ng-show="!cadastroColheita.colheita.atividade.insumos.length">
                    Não há cultivares plantadas nesta safra, talhão e atividade.
                  </span>
                </div>
              </div>
              <div class="col-xs-6 col-md-6">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.data_inicio.$invalid}">
                  <label for="data_inicio">Data Início:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Data"
                      uib-datepicker-popup="dd/MM/yyyy" ng-model="cadastroColheita.colheita.data_inicio" id="data_inicio" name="data_inicio" required
                      is-open="popupDataInicio.opened" show-button-bar="false" datepicker-append-to-body="true">
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default" ng-click="popupDataInicio.opened = !popupDataInicio.opened">
                        <i class="glyphicon glyphicon-calendar"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-md-6">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.data_termino.$invalid}">
                  <label for="data_termino">Data Término:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Data"
                      uib-datepicker-popup="dd/MM/yyyy" ng-model="cadastroColheita.colheita.data_termino" id="data_termino" name="data_termino" required
                      is-open="popupDataTermino.opened" show-button-bar="false" datepicker-append-to-body="true">
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default" ng-click="popupDataTermino.opened = !popupDataTermino.opened">
                        <i class="glyphicon glyphicon-calendar"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-md-6">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.area_total_ha.$invalid}">
                  <label for="area_total_ha">Área total:</label>
                  <div class="input-group">
                    <input type="number" string-to-number class="form-control"
                           id="area_total_ha" name="area_total_ha"
                           required
                           ng-model="cadastroColheita.colheita.area_total_ha" placeholder="Área total em ha"
                           autocomplete="off" min="0.01"
                           ng-change="cadastroColheita.changeTotalColhido('sc')">
                    <span class="input-group-addon">ha</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-md-6" ng-if="!cadastroColheita.isCana()">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.total_colhido_kg.$invalid}">
                  <label for="total_colhido_kg">Total colhido em kg:</label>
                  <div class="input-group">
                    <input type="number" string-to-number class="form-control"
                           id="total_colhido_kg" name="total_colhido_kg"
                           ng-model="cadastroColheita.colheita.total_colhido_kg" placeholder="Total colhido em kg"
                           ng-required="!cadastroColheita.totalColhidoSc"
                           autocomplete="off" min="0.01"
                           ng-change="cadastroColheita.changeTotalColhido('kg')">
                    <span class="input-group-addon">kg</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-xs-push-6" ng-if="!cadastroColheita.isCana()">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.total_colhido_sc.$invalid}">
                  <label for="total_colhido_sc">Total colhido em sc/ha:</label>
                  <div class="input-group">
                    <input type="number" string-to-number class="form-control"
                           id="total_colhido_sc" name="total_colhido_sc"
                           ng-model="cadastroColheita.totalColhidoSc" placeholder="Total colhido em sacos/ha"
                           ng-required="!cadastroColheita.colheita.total_colhido_kg"
                           autocomplete="off" min="0.01"
                           ng-change="cadastroColheita.changeTotalColhido('ton')">
                    <span class="input-group-addon">sc/ha</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-md-6" ng-if="cadastroColheita.isCana()">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.total_colhido_ton.$invalid}">
                  <label for="total_colhido_ton">Total colhido em ton:</label>
                  <div class="input-group">
                    <input type="number" string-to-number class="form-control"
                           id="total_colhido_ton" name="total_colhido_ton"
                           ng-model="cadastroColheita.colheita.total_colhido_ton" placeholder="Total colhido em ton"
                           autocomplete="off" min="0.01"
                           ng-change="cadastroColheita.changeTotalColhido('ton')">
                    <span class="input-group-addon">ton</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-6" ng-if="cadastroColheita.isCana()">
                <div class="form-group" ng-class="{'has-error': cadastroColheita_form.atr_medio.$invalid}">
                  <label for="atr_medio">ATR médio:</label>
                  <div class="input-group">
                    <input type="number" string-to-number class="form-control"
                           id="atr_medio" name="atr_medio"
                           ng-model="cadastroColheita.colheita.atr_medio" placeholder="ATR médio"
                           ng-required="!cadastroColheita.atrMedio"
                           autocomplete="off" min="0.01">
                    <span class="input-group-addon">kg</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-6" ng-if="cadastroColheita.isCana()">
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" ng-model="cadastroColheita.colheita.change_corte"> Colheita do talhão totalmente finalizado
                      <div class="text-cinza">Ao marcar essa opção o corte da cana será alterado</div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row pull-right padding-top-10">
      <div class="col-xs-12 btn-group">
        <button class="btn btn-default btn-sm btn-action" type="button" ng-click="cadastroColheita.goToShow()">Cancelar</button>

        <button class="btn btn-success btn-sm btn-action" type="submit"
                ng-disabled="cadastroColheita_form.$invalid" >
          Salvar <i class="fa fa-check"></i>
        </button>
      </div>
    </div>
  </form>
</div>
